<template>
  <div>
    <portlet
      :icon="'fas fa-question-circle'"
      :title="''"
      :actions-block="true"
      :fullheight="true"
      class="portlet-pt-20"
    >
      <template slot="actionsBlock">
        <button class="btn btn-secondary" @click="$router.go(-1)">
          <i class="fas fa-long-arrow-left mr-2"></i> Back
        </button>
      </template>

      <template slot="portletBody">
        <evaluationForm :user="user" />
      </template>
    </portlet>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import evaluationForm from "@/components/engagement/forms/evaluationForm.vue";


export default {
  name: "evaluation",
  props: [],
  mixins: [],
  components: {
      evaluationForm
  },
  data() {
    return {
      user: {},
    };
  },
  computed: {
    ...mapGetters("company", ["getConfig", "getActivities"]),
    ...mapGetters("userData", ["getMyDepartments"]),
    ...mapGetters("users", ["getMe", "getClaims"]),
  },
  mounted() {
    this.user = this.$route.params.userId
  },
  methods: {},
//   async created() {
//     this.$store.commit("setLoading", true);
//     this.$FUNCTIONS
//       .Users("getUserById", this.$route.params.userId)
//       .then((res) => {
//         this.user = res.data;
//         this.$store.commit("setLoading", false);
//       })
//       .catch((e) => {
//         this.$store.commit("setLoading", false);
//       });
//   },
};
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/engagement/_EmployeeOverviewInDepth.scss";
</style>
